<template>
  <div class="homework-page" id="homework-page">
    <BeginTask v-if="data.status == '0'" @onBegin="onBegin" :data="data" />
    <div
      class="do-homework"
      v-if="data.status == '1' || data.status == '0'"
      v-show="data.status == '1'"
    >
      <Countdown
        @onFinish="onFinish"
        v-if="data.timeLimitSeconds && data.status == '1'"
        status="countdown"
        :time="data.timeLeft * 1000"
      />
      <div class="task-container">
        <div class="composition-requirement" v-if="showCompositionRequirement">
          <div class="composition-title">{{ data.title }}</div>
          <template v-if="data.simpleTaskSaveDto.content">
            <div class="composition-label">作文要求</div>
            <div
              class="composition-content"
              v-html="data.simpleTaskSaveDto.content"
            ></div>
          </template>
          <template v-if="data.simpleTaskSaveDto.contentUrl">
            <div class="composition-label">要求附件</div>
            <img
              class="composition-attachment"
              :src="data.simpleTaskSaveDto.contentUrl"
              alt=""
              @click="previewAttachment(data.simpleTaskSaveDto.contentUrl)"
            />
          </template>
        </div>
        <div
          :class="`task-detail ${data.paperType == '5' ? '' : ''}`"
          :style="
            data.paperType == '5'
              ? `height: ${94 - answerSheetVH}vh; overflow-y: auto;`
              : ''
          "
          id="task-detail"
        >
          <div
            class="task-content"
            :class="{ 'task-content--hidden': showCompositionRequirement }"
            v-html="data.content"
          ></div>
          <AnswerSheet
            v-if="data.paperType == '5'"
            @submit="onSubmit"
            :answerSheetVH="answerSheetVH"
            :data="data"
            :submit-disabled="isSubmitting"
          />
        </div>
        <div class="btn-container" v-if="data.paperType != '5'">
          <van-button
            class="paizhao-btn"
            style="margin: 0 10px"
            @click="onPhoto"
            round
            type="danger"
            block
            v-if="
              data.paperType == '7' ||
                (data.type == '3' &&
                  data.paperFormat &&
                  data.paperFormat !== '')
            "
            >拍照
            <!-- <van-icon
              class="tip-icon"
              @click.stop="showTip = true"
              name="warning"
            /> -->
          </van-button>
          <van-button
            style="margin: 0 10px"
            @click="onSubmit"
            round
            type="primary"
            block
            :disabled="isSubmitting"
            v-if="query.paperDetail !== '1'"
            >完成练习</van-button
          >
        </div>
      </div>
    </div>
    <!-- <div class="do-homework"> -->
    <div class="do-homework" v-if="data.status == '4' && result.id">
      <div class="task-container">
        <TaskEvaluation
          id="task-result"
          :data="data"
          :isStudent="isStudent"
          :result="result"
        />
        <div v-if="urlList.length > 0">
          <p style="margin: 20px 0 0 0">原图：</p>
          <img
            style="margin-top: 5px;"
            v-for="item in urlList"
            :key="item"
            :src="item"
            alt=""
          />
        </div>
      </div>
    </div>
    <van-popup
      class="tip-popup"
      v-model="showTip"
      closeable
      :close-on-click-overlay="false"
    >
      <!-- <p class="dcsp-tip">
      1.请同学避免书写空行，可以在不会的题目下打上x<br />
      2.避免写单词的时候出现上下两行的出现，可能会造成错位的情况<br />
      3.对于写错的单词，请在涂改时全部涂掉<br />
      4.上传图片时，避免出现非单词以外的文字，若出现可重拍或裁剪掉无关内容<br />
      5.您的姓名请请写在最上方 6.一个单词或词汇不能换行书写<br />
      7.尽量保持一行一个单词或词组，在书写是尽量注意席号和单词的混潜，如1和L，13和B、9和g尽量保持书写的规范<br />
      8.序号和字母之间，单词和单词之间尽量避免空隙过大
    </p> -->
      <!-- <div class="img-box"> -->
      <img
        class="tip-img"
        src="https://jiongyi-1305135066.cos.ap-shanghai.myqcloud.com/exam/0069/2026/02/09/1927899277170839880.png"
        alt=""
      />
      <!-- </div> -->
    </van-popup>

    <!-- 语音录入弹窗：knowledgeType 为 28/33 的小题，答题输入框右侧录音图标触发。
         录音结束走 上传 -> ASR -> 轮询结果 的既有链路（与后台 english-user-management
         的 StudentTask 同一套接口 /api/base/upload、asr、asrResult），识别结果落在灰色
         区域内可手动修改/删除，点「确认」写回该小题的答题输入框并同步缓存。 -->
    <van-popup
      class="voice-popup"
      v-model="voiceDialogVisible"
      :close-on-click-overlay="false"
      @closed="onVoicePopupClosed"
    >
      <div class="voice-popup__header">
        <span class="voice-popup__title">语音录入</span>
        <span class="voice-popup__close" @click="closeVoiceDialog">×</span>
      </div>
      <div class="voice-popup__body">
        <div
          class="voice-input-area"
          :class="{
            'is-recording': voiceRecording,
            'is-loading': voiceAsrLoading,
            'is-editing': voiceText && !voiceRecording && !voiceAsrLoading,
          }"
        >
          <template v-if="voiceAsrLoading">
            <i class="voice-input-spin"></i>
            <span>语音识别中...</span>
          </template>
          <template v-else-if="voiceRecording">
            <span class="voice-input-mic-icon voice-input-pulse">
              <svg viewBox="0 0 1024 1024" aria-hidden="true">
                <path
                  d="M512 640a128 128 0 0 0 128-128V256a128 128 0 1 0-256 0v256a128 128 0 0 0 128 128z"
                />
                <path
                  d="M768 448a32 32 0 0 0-32 32v32a224 224 0 1 1-448 0v-32a32 32 0 1 0-64 0v32c0 146.4 109.6 267.5 251.2 285.8V896H384a32 32 0 0 0 0 64h256a32 32 0 0 0 0-64H544v-98.2C685.6 779.5 800 658.4 800 512v-32a32 32 0 0 0-32-32z"
                />
              </svg>
            </span>
            <span>正在录音，点击下方按钮结束</span>
          </template>
          <template v-else-if="voiceText">
            <textarea
              ref="voiceInput"
              class="voice-input-textarea"
              v-model="voiceText"
              placeholder="可手动修改或删除识别结果"
            ></textarea>
          </template>
          <template v-else>
            <span class="voice-input-placeholder"
              >点击下方「开始录音」进行语音录入</span
            >
          </template>
        </div>

        <div class="voice-input-actions" v-if="!voiceAsrLoading">
          <div
            class="voice-input-btn"
            :class="{
              'is-recording': voiceRecording,
              'is-loading': voiceAsrLoading,
            }"
            @click="onVoiceBtnClick"
          >
            <svg
              v-if="!voiceRecording"
              class="voice-btn-icon"
              viewBox="0 0 1024 1024"
              aria-hidden="true"
            >
              <path
                d="M512 640a128 128 0 0 0 128-128V256a128 128 0 1 0-256 0v256a128 128 0 0 0 128 128z"
              />
              <path
                d="M768 448a32 32 0 0 0-32 32v32a224 224 0 1 1-448 0v-32a32 32 0 1 0-64 0v32c0 146.4 109.6 267.5 251.2 285.8V896H384a32 32 0 0 0 0 64h256a32 32 0 0 0 0-64H544v-98.2C685.6 779.5 800 658.4 800 512v-32a32 32 0 0 0-32-32z"
              />
            </svg>
            <span>{{ voiceRecording ? "结束录音" : "开始录音" }}</span>
          </div>
          <div
            v-if="voiceText && !voiceRecording && !voiceAsrLoading"
            class="voice-input-btn voice-input-confirm"
            @click="confirmVoiceResult"
          >
            <span>确认</span>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import Vue from "vue";
import req from "../util/req";
import { mapQuery } from "../util/URLUtils";
import insert from "../util/insertDOM";
import { getInputSortUtil } from "@/util/preTask";
// 给分点内容（作文要求 / 要求附件）按小题注入，逻辑与 preTask.vue 预览共用
import {
  renderFlowExtras,
  isFlowExtraPaperType,
  isWritingKnowledgeType,
} from "@/util/flowExtra";
// 语音录入（knowledgeType 28/33 小题）：答题输入框右侧录音图标 + 录音转文字链路
import { renderVoiceInputButtons } from "@/util/voiceInput";
import { voiceToText } from "@/util/asr";
import Recorder2 from "recorder-core"; // 录音核心库（与 RecoderExam.vue、后台同源）
import "recorder-core/src/engine/mp3";
import "recorder-core/src/engine/mp3-engine";
import Countdown from "../components/Countdown";
import BeginTask from "../components/BeginTask";
import AnswerSheet from "../components/AnswerSheet";
import TaskEvaluation from "../components/TaskEvaluation";
import { Dialog, Toast, ImagePreview, Popup } from "vant";
import bluePlayImg from "../assets/icon-1_14.png";
import grayPlayImg from "../assets/pause.png";
import pauseImg from "../assets/icon-1_27.png";
Vue.use(Popup);
export default {
  name: "Home",
  data() {
    return {
      showTip: false,
      urlList: [],
      isStudent: false,
      location: window.location,
      query: mapQuery(),
      hasEmpty: true,
      data: {},
      result: {},
      answers: [],
      time: 0,
      detailDOM: null,
      audioIndex: -1, // 当前播放的音频索引，-1表示没有音频在播放
      notPlaying: true, // 听力题一次只允许一个在播放
      audioTagList: null,
      audioBtnList: null,
      radioInputList: null,
      checkboxInputList: null,
      textInputList: null,
      textareaInputList: null,
      answerSheetVH: 50,
      resourceShow: false,
      isSubmitting: false,

      pList: null,
      audioSyncInterval: null, // iOS 18.5兼容：状态同步定时器

      // 语音录入（knowledgeType 28/33 小题）
      voiceDialogVisible: false,
      voiceRecording: false,
      voiceAsrLoading: false,
      voiceText: "",
      voiceRec: null,
      voiceTargetInput: null,
    };
  },
  created() {
    this.isStudent = this.query.isStudent == true;
    this.answers = localStorage.getItem("answer" + this.query.id)
      ? JSON.parse(localStorage.getItem("answer" + this.query.id))
      : [];
    if (this.query.paperDetail) this.getPaperDetail();
    else this.getData(true);
  },
  mounted() {
    // 区分安卓/iOS：安卓键盘弹出时需保持固定高度才能正常滚动
    const isAndroid = /android/i.test(navigator.userAgent);
    if (isAndroid) {
      document.getElementById("homework-page").classList.add("android");
    }
    // iOS 18.5兼容：初始化进度条状态
    setTimeout(() => {
      if (this.audioBtnList) {
        for (let i = 0; i < this.audioBtnList.length; i++) {
          this.resetProgressBar(i);
        }
      }
    }, 1000);

    // iOS 18.5兼容：定期检查音频状态同步
    this.audioSyncInterval = setInterval(() => {
      if (this.audioTagList && this.audioBtnList) {
        for (let i = 0; i < this.audioTagList.length; i++) {
          const audio = this.audioTagList[i];
          const isPlaying = !audio.paused && !audio.ended;

          // 检查状态是否同步
          if (this.audioIndex === i && isPlaying && this.notPlaying) {
            // 修复：音频在播放但状态显示为未播放
            this.notPlaying = false;
            this.updateAudioButtonState(i, true);
          } else if (this.audioIndex === i && !isPlaying && !this.notPlaying) {
            // 修复：音频未播放但状态显示为播放中
            this.notPlaying = true;
            this.updateAudioButtonState(i, false);
          }

          // iOS 18.5兼容：检查进度条状态
          if (this.audioIndex === i && isPlaying) {
            // 当前播放的音频：确保进度条正确更新
            if (
              audio.duration &&
              !isNaN(audio.duration) &&
              audio.duration > 0
            ) {
              const progress = audio.currentTime / audio.duration;
              this.updateProgressBar(i, progress);
            }
          } else {
            // 非当前播放的音频：确保进度条重置
            this.resetProgressBar(i);
          }
        }
      }
    }, 500); // 每500ms检查一次

    // iOS 18.5兼容：监听页面可见性变化
    this.handleVisibilityChange = () => {
      if (!document.hidden && this.audioBtnList) {
        // 页面重新可见时，重置所有非播放音频的进度条
        setTimeout(() => {
          for (let i = 0; i < this.audioBtnList.length; i++) {
            if (this.audioIndex !== i) {
              this.resetProgressBar(i);
            }
          }
        }, 100);
      }
    };
    document.addEventListener("visibilitychange", this.handleVisibilityChange);
  },
  beforeDestroy() {
    // 清理定时器
    if (this.audioSyncInterval) {
      clearInterval(this.audioSyncInterval);
    }

    // 清理页面可见性监听器
    document.removeEventListener(
      "visibilitychange",
      this.handleVisibilityChange,
    );
  },
  computed: {
    // type=12（作文）：是否展示「作文要求」信息块
    // 展示时隐藏 task-detail 里的正文内容（避免与要求块重复）
    showCompositionRequirement() {
      const d = this.data || {};
      const s = d.simpleTaskSaveDto;
      return !!(
        d.type == "12" &&
        d.title &&
        s &&
        (s.content || s.contentUrl)
      );
    },
  },
  methods: {
    // radio类型的input，让其父元素单独占一行
    setRadioParentBlock(radioInputList) {
      if (!radioInputList || !radioInputList.length) return;
      const processedParents = new Set();
      for (let i = 0; i < radioInputList.length; i++) {
        const parent = radioInputList[i].parentNode;
        if (!parent || parent.nodeType !== 1 || processedParents.has(parent)) {
          continue;
        }
        processedParents.add(parent);
        parent.style.display = "block";
        parent.style.width = "100%";
        // 每个radio选项上下添加5px间距
        parent.style.marginTop = "5px";
        parent.style.marginBottom = "5px";
        // 清除父元素内部开头的所有空格
        this.clearLeadingSpaces(parent);
      }
    },

    // 清除元素内部开头的所有空格（含普通空格和 &nbsp;）
    clearLeadingSpaces(el) {
      if (!el) return;
      while (el.firstChild) {
        const node = el.firstChild;
        // 仅处理文本节点
        if (node.nodeType === 3) {
          const trimmed = node.nodeValue.replace(/^[\s\u00a0]+/, "");
          if (trimmed === "") {
            // 纯空白节点，直接移除，继续向后检查
            el.removeChild(node);
            continue;
          }
          // 去掉开头空白后保留其余内容
          node.nodeValue = trimmed;
        }
        break;
      }
    },

    // iOS 18.5兼容：更新音频按钮状态
    updateAudioButtonState(index, isPlaying) {
      if (!this.audioBtnList || !this.audioBtnList[index]) return;

      if (isPlaying) {
        this.audioBtnList[index].children[1].src = grayPlayImg;
        this.audioBtnList[index].children[0].style.display = "block";
        // 重置其他按钮状态和进度条
        for (let j = 0; j < this.audioBtnList.length; j++) {
          if (j !== index) {
            this.audioBtnList[j].children[1].src = bluePlayImg;
            this.audioBtnList[j].children[0].style.display = "none";
            // iOS 18.5兼容：重置其他音频的进度条
            this.resetProgressBar(j);
          }
        }
      } else {
        this.audioBtnList[index].children[1].src = pauseImg;
        this.audioBtnList[index].children[0].style.display = "none";
        // iOS 18.5兼容：暂停时重置进度条
        this.resetProgressBar(index);
      }
    },

    // iOS 18.5兼容：重置进度条
    resetProgressBar(index) {
      if (!this.audioBtnList || !this.audioBtnList[index]) return;
      try {
        const progressElement = this.audioBtnList[index].children[0]
          .children[1];
        if (progressElement && progressElement.style) {
          progressElement.style.strokeDasharray = "0px 3140px";
        }
      } catch (error) {
        console.log("Reset progress bar error:", error);
      }
    },

    // iOS 18.5兼容：更新进度条
    updateProgressBar(index, progress) {
      if (!this.audioBtnList || !this.audioBtnList[index]) return;
      try {
        const progressElement = this.audioBtnList[index].children[0]
          .children[1];
        if (progressElement && progressElement.style) {
          const result = progress * 3140;
          progressElement.style.strokeDasharray = result + "px 3140px";
        }
      } catch (error) {
        console.log("Update progress bar error:", error);
      }
    },

    postMessage() {
      wx.miniProgram.postMessage({ data: { foo: "bar" } });
    },

    previewAttachment(url) {
      if (!url) return;
      ImagePreview({
        images: [url],
        closeable: true,
      });
    },

    /**
     * 按小题注入「作文要求 / 要求附件」（来源：flows[].scorePointList，见 util/flowExtra.js）。
     * 试卷预览（getPaperDetail）与学生做作业（getData）共用本方法，保证两种模式表现一致。
     * 容器：正文 #task-detail 优先，答题卡 .answer-sheet-scroll 兜底（答题卡本身也在 #task-detail 内）。
     * 同步执行，调用方需自行保证 DOM 已渲染；
     * 若在 getInputSortUtil 之前调用，空位([name=tagId])还在，才能定位到对应小题插入。
     */
    injectFlowExtras(flowList) {
      const list = flowList || [];
      if (!list.length) return;
      renderFlowExtras(list, [
        "task-detail",
        document.querySelector(".answer-sheet-scroll"),
      ]);
      // 注入的「要求附件」图片点击放大，与顶部作文要求块的 previewAttachment 行为一致
      const extraImgList = document.querySelectorAll(
        ".essay-requirement__img",
      );
      for (let i = 0; i < extraImgList.length; i++) {
        extraImgList[i].addEventListener("click", (e) => {
          this.previewAttachment(e.target.src);
        });
      }
    },

    /**taskFlowList 中 knowledgeType === '12'（写作）小题的 tagId 集合**/
    getWritingTagMap(flowList) {
      const map = {};
      const list = Array.isArray(flowList) ? flowList : [];
      list.forEach((f) => {
        // 兼容后端返回 number 12 与 string "12"
        if (f && f.tagId && isWritingKnowledgeType(f.knowledgeType)) {
          map[f.tagId] = true;
        }
      });
      return map;
    },

    /**
     * 写作(12)小题的答案空位在试卷 HTML 里是单行 input，这里替换成满宽（width:100%）、
     * 10 行高的 textarea，便于学生分段作答。
     * name / id 保持原样，答案回填（answersToInput）、缓存（getFormDataFromDOM）与
     * 拍照上传（onPhoto）沿用 textarea 分支即可命中。
     * ⚠️ 必须在 textInputList / textareaInputList 取列表之前调用：那两个缓存列表是
     * getFormDataFromDOM()、onPhoto() 的唯一取数来源，替换后新 textarea 才能被
     * textareaInputList 收进去，否则学生填的作文会取不到、存不住。
     * @returns {number} 实际替换的个数
     */
    replaceWritingInputWithTextarea(flowList) {
      const writingTagMap = this.getWritingTagMap(flowList);
      if (!Object.keys(writingTagMap).length) return 0;
      const inputList = document.querySelectorAll("input");
      let count = 0;
      for (let i = 0; i < inputList.length; i++) {
        const input = inputList[i];
        // paperType=8 等情况可能已把 input 换成 span，此时 parentNode 为空，跳过
        if (!input || !input.parentNode) continue;
        if (!input.name || !writingTagMap[input.name]) continue;
        // 只换文本填空类型的空位，避开同名 tagId 下的 radio / checkbox
        const type = input.getAttribute("type") || input.type;
        if (type && type !== "text") continue;
        const textarea = document.createElement("textarea");
        textarea.name = input.name;
        if (input.id) textarea.id = input.id;
        textarea.className = `${
          input.className ? `${input.className} ` : ""
        }writing-answer-textarea`;
        textarea.value = input.value || "";
        textarea.setAttribute("rows", "10");
        input.parentNode.replaceChild(textarea, input);
        count++;
      }
      return count;
    },

    /**
     * 是否为「固定 10 行高度」的写作答案框（.writing-answer-textarea）。
     * 这类 textarea 不能参与页面既有的「随内容自动增高」逻辑
     * （textareaInputList 的 input 事件里 style.height = scrollHeight），
     * 否则输入越多就被撑得越高、永远不出现滚动条——需求是固定 10 行、超出内部滚动。
     */
    isFixedHeightTextarea(el) {
      return !!(
        el &&
        el.classList &&
        el.classList.contains("writing-answer-textarea")
      );
    },

    /* ==================== 语音录入（knowledgeType 28/33 小题） ==================== */

    /**
     * 在 knowledgeType 28/33 小题的答案空位（input / textarea）右侧注入录音图标。
     * 容器与「作文要求」注入保持一致：正文 #task-detail 优先，答题卡 .answer-sheet-scroll 兜底
     * （答题卡嵌在 #task-detail 内，util 侧已用 nextElementSibling 做幂等，不会插两次）。
     */
    injectVoiceInputButtons(flowList) {
      renderVoiceInputButtons(
        flowList,
        ["task-detail", document.querySelector(".answer-sheet-scroll")],
        input => this.openVoiceDialog(input),
      );
    },

    /**打开语音录入弹窗：以该输入框当前内容为初始值，避免识别结果覆盖已有作答**/
    openVoiceDialog(input) {
      if (!input) return;
      this.voiceTargetInput = input;
      this.voiceText = input.value || "";
      this.voiceDialogVisible = true;
    },

    /**关闭语音录入弹窗：若仍在录音则停止并丢弃本轮录音**/
    closeVoiceDialog() {
      if (this.voiceRecording) this.stopVoiceRecord(false);
      if (this.voiceRec) {
        try {
          this.voiceRec.close();
        } catch (e) {
          // ignore
        }
        this.voiceRec = null;
      }
      this.voiceRecording = false;
      this.voiceDialogVisible = false;
    },

    /**弹窗收起动画结束后再清状态，避免文字在关闭过程中闪一下**/
    onVoicePopupClosed() {
      this.voiceTargetInput = null;
      this.voiceText = "";
      this.voiceRecording = false;
      this.voiceAsrLoading = false;
    },

    /**开始录音 / 结束录音（识别中禁止点击）**/
    onVoiceBtnClick() {
      if (this.voiceAsrLoading) return;
      if (this.voiceRecording) this.stopVoiceRecord(true);
      else this.startVoiceRecord();
    },

    /**开始录音**/
    async startVoiceRecord() {
      if (this.voiceAsrLoading) return;
      // 复用 recorder-core 全局 AudioContext，并在点击手势内等其真正 running 后再 open/start，
      // 否则首次点击会因 AudioContext 处于 suspended 而无响应
      await this.ensureVoiceCtxRunning();
      try {
        const rec = Recorder2({
          type: "mp3",
          sampleRate: 16000,
          bitRate: 96,
          runningContext: this.getVoiceRunningCtx(),
        });
        rec.open(
          () => {
            rec.start();
            this.voiceRec = rec;
            this.voiceRecording = true;
          },
          () => {
            Toast("录音设备打开失败，请检查麦克风权限");
            this.voiceRecording = false;
          },
        );
      } catch (e) {
        console.error("语音录入录音初始化失败:", e);
        Toast("录音设备打开失败，请检查麦克风权限");
        this.voiceRecording = false;
      }
    },

    /**
     * 停止录音并做语音转文字：上传音频 -> 触发 ASR -> 轮询结果（见 util/asr.js）。
     * process=true 时把识别结果累加到灰色录入区（可手动修改/删除）；
     * process=false（关闭弹窗/重置）时丢弃本次录音。
     */
    stopVoiceRecord(process = true) {
      const rec = this.voiceRec;
      this.voiceRecording = false;
      if (!rec) {
        this.voiceAsrLoading = false;
        return;
      }
      rec.stop(async blob => {
        try {
          if (!process) return;
          this.voiceAsrLoading = true;
          const text = await voiceToText(blob);
          if (!text) {
            Toast("录音内容为空，请重新录音");
            return;
          }
          // 多次录音时追加而非覆盖
          const prev = this.voiceText || "";
          this.voiceText = prev ? `${prev} ${text}` : text;
        } catch (e) {
          console.error("语音录入识别失败:", e);
          Toast("语音识别失败，请重试");
        } finally {
          try {
            rec.close();
          } catch (err) {
            // ignore
          }
          this.voiceRec = null;
          this.voiceAsrLoading = false;
        }
      });
    },

    /**确认录入：把灰色区域（可能被手动修改/删除过）的内容写回该小题的答案空位**/
    confirmVoiceResult() {
      if (this.voiceRecording || this.voiceAsrLoading) return;
      const input = this.voiceTargetInput;
      if (input && input.parentNode) {
        input.value = this.voiceText || "";
        // 空位宽度自适应（与手动输入同一条链路，见 getData 里的 input 事件）
        const clientWidth =
          (document.body.clientWidth ||
            document.getElementsByTagName("html")[0].offsetWidth) * 0.92;
        const width = Math.min(Math.max(input.scrollWidth, 80), clientWidth);
        input.style.width = width + "px";
        // 同步 answers 并保存缓存（getFormDataFromDOM 内部会调 SaveCacheHandler）
        this.getFormDataFromDOM();
      }
      this.closeVoiceDialog();
    },

    /**复用 recorder-core 全局 AudioContext（suspended 时在点击手势内 resume）**/
    getVoiceRunningCtx() {
      const ctx = Recorder2.GetContext();
      if (ctx && ctx.state === "suspended") {
        ctx.resume();
      }
      return ctx;
    },

    /**在点击手势内激活全局 AudioContext 并等待其真正 running**/
    async ensureVoiceCtxRunning() {
      const ctx = Recorder2.GetContext();
      if (ctx && ctx.state !== "running") {
        try {
          await ctx.resume();
        } catch (e) {
          console.warn("AudioContext resume 失败:", e);
        }
      }
    },

    getFormDataFromDOM() {
      let hasEmpty = false;
      // 单选题多个input同一个id，这里用对象储存，避免重复记录
      const radioAnswers = {};
      const checkAnswers = {};
      const answers = [];
      // 获取所有选择题填写答案
      for (let i = 0; i < this.radioInputList.length; i++) {
        const item = this.radioInputList[i];
        const text = item.value;
        const tagId = item.attributes.name.value;
        radioAnswers[tagId] = radioAnswers[tagId] || "";
        if (item.checked) {
          radioAnswers[tagId] = text.slice(0, 1);
        }
      }
      for (const key in radioAnswers) {
        if (!radioAnswers[key]) {
          hasEmpty = true;
        }
        answers.push({
          tagId: key,
          text: radioAnswers[key],
        });
      }

      // 获取所有多选题填写答案
      for (let i = 0; i < this.checkboxInputList.length; i++) {
        const item = this.checkboxInputList[i];
        const text = item.value;
        const tagId = item.attributes.name.value;
        checkAnswers[tagId] = checkAnswers[tagId] || "";
        if (item.checked) {
          checkAnswers[tagId] += text.slice(0, 1);
        }
      }
      for (const key in checkAnswers) {
        if (!checkAnswers[key]) {
          hasEmpty = true;
        }
        answers.push({
          tagId: key,
          text: checkAnswers[key],
        });
      }

      // 获取所有填空题填写答案
      for (let i = 0; i < this.textInputList.length; i++) {
        const item = this.textInputList[i];
        const text = item.value;
        const tagId = item.attributes.name.value;
        if (!text) {
          hasEmpty = true;
        }
        answers.push({
          tagId,
          text,
        });
      }

      // 获取所有作文题填写答案
      for (let i = 0; i < this.textareaInputList.length; i++) {
        const item = this.textareaInputList[i];
        const text = item.value;
        const tagId = item.attributes.name.value;
        if (!text) {
          hasEmpty = true;
        }
        answers.push({
          tagId,
          text,
        });
      }
      localStorage.setItem("answer" + this.query.id, JSON.stringify(answers));
      this.answers = answers;

      this.hasEmpty = hasEmpty;
      this.SaveCacheHandler();
    },

    /**保存缓存**/
    SaveCacheHandler() {
      let param = { answers: this.answers, id: this.query.id };
      req.post("/api/exam/studentApi/saveCache", param).then((res) => {
        const errorCode = res.data.errorCode;
        const errorDesc = res.data.errorDesc;
        if (errorCode == "100405") {
          Dialog.confirm({
            title: "提示",
            message: "当前用户信息已失效，请重新登录!",
            allowHtml: true,
          }).then(() => {
            // wx.miniProgram.redirectTo({
            //   url: "/pages/select-server/index",
            // });
            wx.miniProgram.redirectTo({
              url: "/pages/login/index",
            });
          });
        }
      });
    },

    /**获取缓存**/
    getStudentTesrLoadCache() {
      req
        .post("/api/exam/studentApi/loadCache", { id: this.query.id })
        .then((res) => {
          const { data } = res.data;
          if (data && data.length > 0) {
            this.answers = data;
            this.answersToInput(data);
          }
        });
    },
    // 把缓存的答案填回表单
    answersToInput(answers) {
      for (let i = 0; i < answers.length; i++) {
        const item = answers[i];
        const dom = document.querySelectorAll('[name="' + item.tagId + '"]');
        if (dom.length > 1) {
          for (let j = 0; j < dom.length; j++) {
            if (item.text && item.text.indexOf(dom[j].value) > -1) {
              // if (item.text && dom[j].value.indexOf(item.text) > -1) {
              dom[j].checked = true;
            }
          }
        } else if (dom.length == 1) {
          dom[0].value = item.text;
        }
      }
    },
    getResult() {
      req
        .post(
          this.query.api && this.query.api == "exam"
            ? "/api/exam/userTaskResult"
            : "/api/exam/appApi/userTaskResult",
          {
            id: this.query.id,
          },
        )
        .then((res) => {
          res.data.data.averageScore = Math.ceil(res.data.data.averageScore);
          this.result = res.data.data;
          this.urlList = this.result.url.split("|");
          if (this.data.paperType === "8") {
            this.wakongHandle();
          }
        });
    },
    getData(init) {
      req
        .post(
          this.query.api && this.query.api == "exam"
            ? "/api/exam/userTaskDetail"
            : "/api/exam/appApi/userTaskDetail",
          {
            id: this.query.id,
          },
        )
        .then((res) => {
          const data = res.data.data || {};
          this.data = data;
          const that = this;
          document.title = data.taskTitle;
          // 状态（0：待做 1：进行中 2：待上传 3：待批改 4：已批改 5：过期）
          if (data.status == "0" || data.status == "5") {
            // 重置成待做状态后，清除缓存的答案
            this.data.status = "0";
            localStorage.setItem("answer" + this.query.id, "[]");
            this.answers = [];
          } else if (data.status == "2") {
            Toast("作业已到时间限制，正在上传已填写的作业...");
            this.doSubmitReq(true, false);
            return;
          } else if (data.status == "3") {
            Toast("试卷批改中，正在返回作业列表...");
            setTimeout(() => {
              wx.miniProgram.redirectTo({
                url: "/pages/common-index/index",
              });
            }, 1000);
            return;
          }
          // else if (data.status == "5") {
          //   Toast("试卷已过期，正在返回首页...");
          //   setTimeout(() => {
          //     wx.miniProgram.redirectTo({
          //       url: "/pages/common-index/index",
          //     });
          //   }, 1000);
          //   return;
          // }
          // console.log(this.query.status,'status');

          if (data.status == "4" && !this.query.status) {
            this.getResult();
          }
          if (data.content && init) {
            if (data.paperFormat && data.paperFormat === 1)
              data.content = insert.getPaperContent(data);
            setTimeout(() => {
              const detailDOM = document.querySelector("#task-detail");
              const imgDomList = document.querySelectorAll("#task-detail img");
              const imgList = [];
              if (imgDomList && imgDomList.length) {
                for (let i = 0; i < imgDomList.length; i++) {
                  imgList.push(imgDomList[i].src);
                }
                for (let i = 0; i < imgDomList.length; i++) {
                  const item = imgDomList[i];
                  item.setAttribute("loading", "lazy");
                  item.setAttribute("decoding", "async");
                  item.addEventListener("click", (e) => {
                    const src = e.target.src;
                    ImagePreview({
                      images: imgList,
                      closeable: true,
                      startPosition: i,
                    });
                    // console.log("imgDomList click", e.target.src);
                  });
                }
              }

              // 插入播放按钮
              const audioTagList = document.querySelectorAll("audio");
              if (audioTagList && audioTagList.length > 0) {
                // iOS音频初始化处理
                for (let i = 0; i < audioTagList.length; i++) {
                  audioTagList[i].setAttribute("preload", "metadata");
                  audioTagList[i].setAttribute("webkit-playsinline", "true");
                  audioTagList[i].setAttribute("playsinline", "true");
                }

                for (let i = 0; i < audioTagList.length; i++) {
                  const newNode = document.createElement("div");
                  newNode.className = "play-btn-container";
                  newNode.id = "audio" + i;
                  const parent = audioTagList[i].parentNode;
                  // newNode.innerHTML = `
                  //   <svg viewBox="0 0 1060 1060"><path d="M 530 530 m 0, -500 a 500, 500 0 1, 1 0, 1000 a 500, 500 0 1, 1 0, -1000" class="van-circle__hover" style="fill: none; stroke: rgb(255, 255, 255); stroke-width: 60px;"></path><path d="M 530 530 m 0, -500 a 500, 500 0 1, 1 0, 1000 a 500, 500 0 1, 1 0, -1000" stroke="#ff1717" class="van-circle__layer" style="fill: none; stroke: rgb(255, 23, 23); stroke-width: 61px; stroke-dasharray: 0px, 3140px;"></path></svg>
                  //   <img src="${i == 0 ? bluePlayImg : grayPlayImg}" />
                  // `;
                  newNode.innerHTML = `
                    <svg viewBox="0 0 1060 1060"><path d="M 530 530 m 0, -500 a 500, 500 0 1, 1 0, 1000 a 500, 500 0 1, 1 0, -1000" class="van-circle__hover" style="fill: none; stroke: rgb(255, 255, 255); stroke-width: 60px;"></path><path d="M 530 530 m 0, -500 a 500, 500 0 1, 1 0, 1000 a 500, 500 0 1, 1 0, -1000" stroke="#ff1717" class="van-circle__layer" style="fill: none; stroke: rgb(255, 23, 23); stroke-width: 61px; stroke-dasharray: 0px, 3140px;"></path></svg>
                    <img src="${bluePlayImg}" /><span style="position: absolute;bottom:-20px;display: inline-block;width: 120px">听力音频${i +
                    1}</span>
                  `;
                  //<button id="btn${i}" style="margin-left: 1.5rem;margin-top: 0.2rem">跳过</button>
                  // parent.insertBefore(newNode, audioTagList[i]);
                  parent.replaceChild(newNode, audioTagList[i]);
                  //跳过的逻辑
                  // parent.addEventListener("click", function(event) {
                  //   if (event.target.tagName === "BUTTON") {
                  //     event.stopPropagation();
                  //     let i = event.target.id.substring(3, 4)-0;
                  //     audioTagList[i].pause()
                  //     audioTagList[i].currentTime = 0;
                  //     that.notPlaying = true;
                  //     that.audioIndex =
                  //       that.audioIndex > i + 1 ? that.audioIndex : i + 1;
                  //     that.audioBtnList[i].children[0].style.display = "none";
                  //     that.audioBtnList[i].children[1].src = bluePlayImg;
                  //     for (let j = 0; j < that.audioBtnList.length; j++) {
                  //       that.audioBtnList[j].children[1].src = bluePlayImg;
                  //     }
                  //   }
                  // });
                  audioTagList[i].addEventListener("ended", (event) => {
                    that.notPlaying = true;
                    that.audioIndex = -1;
                    that.audioBtnList[i].children[0].style.display = "none";
                    that.audioBtnList[i].children[1].src = bluePlayImg;
                    for (let j = 0; j < that.audioBtnList.length; j++) {
                      that.audioBtnList[j].children[1].src = bluePlayImg;
                    }
                  });
                  audioTagList[i].addEventListener("timeupdate", (event) => {
                    const result =
                      (that.audioTagList[i].currentTime /
                        that.audioTagList[i].duration) *
                      3140;
                    that.audioBtnList[
                      i
                    ].children[0].children[1].style.strokeDasharray =
                      result + "" + "px 3140px";
                  });
                  audioTagList[i].addEventListener("play", (event) => {
                    // iOS 18.5兼容：确保状态正确同步
                    that.notPlaying = false;
                    that.audioIndex = i;
                    that.audioBtnList[i].children[0].style.display = "block";

                    // 重置所有按钮状态，确保只有当前播放的显示正确状态
                    for (let j = 0; j < that.audioBtnList.length; j++) {
                      if (i == j) {
                        that.audioBtnList[j].children[1].src = grayPlayImg;
                      } else {
                        that.audioBtnList[j].children[1].src = bluePlayImg;
                        that.audioBtnList[j].children[0].style.display = "none";
                      }
                    }
                  });
                  audioTagList[i].addEventListener("pause", (event) => {
                    that.notPlaying = true;
                    if (
                      that.audioIndex >= 0 &&
                      that.audioBtnList[that.audioIndex]
                    ) {
                      that.audioBtnList[
                        that.audioIndex
                      ].children[1].src = pauseImg;
                    }
                  });

                  // iOS兼容性：添加音频加载和错误处理
                  audioTagList[i].addEventListener("loadstart", (event) => {
                    console.log("Audio loading started");
                  });

                  audioTagList[i].addEventListener("error", (event) => {
                    console.log("Audio error:", event);
                    that.notPlaying = true;
                    that.audioIndex = -1;
                    if (that.audioBtnList && that.audioBtnList[i]) {
                      that.audioBtnList[i].children[1].src = bluePlayImg;
                      that.audioBtnList[i].children[0].style.display = "none";
                    }
                  });
                }
              }
              that.audioTagList = audioTagList;
              setTimeout(() => {
                const audioBtnList = document.querySelectorAll(
                  ".play-btn-container",
                );
                for (let i = 0; i < audioBtnList.length; i++) {
                  if (audioBtnList[i]) {
                    audioBtnList[i].children[1].style.display = "block";
                    audioBtnList[i].addEventListener("click", (e) => {
                      const item = e.currentTarget;
                      // 当前点击的第几个audio
                      const index = Number(item.id.slice(5));

                      // 如果点击的是当前正在播放的音频，则暂停/播放
                      if (that.audioIndex == index && !that.notPlaying) {
                        that.audioTagList[index].pause();
                        // iOS 18.5兼容：使用统一的状态更新函数
                        that.updateAudioButtonState(index, false);
                        that.notPlaying = true;
                      } else {
                        // 先暂停所有正在播放的音频
                        for (let j = 0; j < that.audioTagList.length; j++) {
                          if (!that.audioTagList[j].paused) {
                            that.audioTagList[j].pause();
                            that.audioBtnList[j].children[1].src = bluePlayImg;
                            that.audioBtnList[j].children[0].style.display =
                              "none";
                          }
                        }

                        // 立即更新状态和UI（iOS 18.5兼容）
                        that.audioIndex = index;
                        that.notPlaying = false;
                        // iOS 18.5兼容：使用统一的状态更新函数
                        that.updateAudioButtonState(index, true);

                        // 播放点击的音频，iOS兼容处理
                        const playPromise = that.audioTagList[index].play();
                        if (playPromise !== undefined) {
                          playPromise
                            .then(() => {
                              // 播放成功确认（iOS 18.5中可能需要额外确认）
                              setTimeout(() => {
                                if (!that.audioTagList[index].paused) {
                                  that.notPlaying = false;
                                  that.updateAudioButtonState(index, true);
                                }
                              }, 100);
                            })
                            .catch((error) => {
                              // 播放失败时重置状态
                              console.log("Audio play failed:", error);
                              that.notPlaying = true;
                              that.audioIndex = -1;
                              that.audioBtnList[
                                index
                              ].children[1].src = bluePlayImg;
                              that.audioBtnList[
                                index
                              ].children[0].style.display = "none";
                            });
                        } else {
                          // 旧版浏览器兼容
                          that.notPlaying = false;
                          that.updateAudioButtonState(index, true);
                        }
                      }
                    });
                  }
                }
                that.audioBtnList = audioBtnList;
              }, 0);
              that.detailDOM = detailDOM;
              if (!detailDOM) {
                return;
              }
              let cardFlag = false;
              that.pList = document.querySelectorAll("p");
              for (let i = 0; i < that.pList.length; i++) {
                let tag = that.pList[i];
                // 只对未设置text-align的p标签设置默认左对齐，保留内容中已有的对齐样式
                if (!tag.style.textAlign) {
                  tag.style.textAlign = "left";
                }
                // 修复 Word 转 HTML 带来的负 text-indent：负缩进会让首行被容器 overflow-x:hidden 裁切，导致开头文字显示不全。
                // 保留 text-indent 的悬挂缩进效果，仅补等量左内边距把整段右移，使首行回到容器内不被裁切。
                if (tag.style.textIndent && parseFloat(tag.style.textIndent) < 0) {
                  const indentPx = (Math.abs(parseFloat(tag.style.textIndent)) / 72) * 96; // pt -> px
                  const existPad = tag.style.paddingLeft
                    ? parseFloat(tag.style.paddingLeft)
                    : 0;
                  tag.style.paddingLeft = existPad + indentPx + "px";
                }
                if (tag.innerText.includes("A.B.C.")) {
                  tag.style.marginBottom = "28px";
                  cardFlag = true;
                }
              }

              that.radioInputList = document.querySelectorAll(
                'input[type="radio"]',
              );
              // radio类型的input，让其父元素单独占一行
              that.setRadioParentBlock(that.radioInputList);
              if (cardFlag) {
                for (let i = 0; i < that.radioInputList.length; i++) {
                  let tag = that.radioInputList[i];
                  tag.style.width = "24px";
                  // if (!tag.value.includes("A")) {
                  //   tag.style.marginLeft = "20px";
                  // }
                  if ("EFGHIJKMNOPQRSTUVWXYZ".includes(tag.value)) {
                    tag.style.marginTop = "10px";
                    tag.style.marginBottom = "28px";
                  }
                }
              }

              that.checkboxInputList = document.querySelectorAll(
                'input[type="checkbox"]',
              );
              if (cardFlag) {
                for (let i = 0; i < that.checkboxInputList.length; i++) {
                  let tag = that.checkboxInputList[i];
                  tag.style.width = "24px";
                  tag.style.marginLeft = "20px";
                }
              }

              // 写作(12)小题：答案空位由单行 input 换成满宽 10 行的 textarea。
              // 必须放在下面取 textInputList / textareaInputList 之前——这两个缓存列表是
              // getFormDataFromDOM()、onPhoto() 的取数来源，换完新 textarea 才能被正确归类。
              // flow 源以 taskFlowList 为准（需求指定），缺失时回落 flows。
              that.replaceWritingInputWithTextarea(
                data.taskFlowList && data.taskFlowList.length
                  ? data.taskFlowList
                  : data.flows,
              );
              that.textInputList = document.querySelectorAll(
                'input[type="text"]',
              );
              that.textareaInputList = document.querySelectorAll("textarea");
              // 首次初始化页面时绑定事件 监听输入变化 重复执行此函数结果不变
              detailDOM.addEventListener("click", (e) => {
                that.getFormDataFromDOM();
              });
              // detailDOM.addEventListener("touchend", () => {
              //   console.log("touchend");
              //   that.getFormDataFromDOM();
              // });
              const clientWidth =
                (document.body.clientWidth ||
                  document.getElementsByTagName("html")[0].offsetWidth) * 0.92;
              for (let i = 0; i < that.textInputList.length; i++) {
                that.textInputList[i].addEventListener("input", (e) => {
                  that.getFormDataFromDOM();
                  let width = Math.max(that.textInputList[i].scrollWidth, 80);
                  width = Math.min(width, clientWidth);
                  that.textInputList[i].style.width = width + "px";
                });
                that.textInputList[i].addEventListener("focus", () => {
                  setTimeout(() => {
                    that.textInputList[i].scrollIntoView({
                      block: "center",
                      behavior: "smooth",
                    });
                  }, 300);
                });
                setTimeout(() => {
                  let width = Math.max(that.textInputList[i].scrollWidth, 80);
                  width = Math.min(width, clientWidth);
                  that.textInputList[i].style.width = width + "px";
                }, 100);
              }
              for (let i = 0; i < that.textareaInputList.length; i++) {
                // 写作(12)小题的答案框固定 10 行高度，不参与下面的「随内容自动增高」，
                // 否则会被 scrollHeight 一路撑高、永远出不来滚动条
                const fixedHeight = that.isFixedHeightTextarea(
                  that.textareaInputList[i],
                );
                that.textareaInputList[i].addEventListener("input", (e) => {
                  that.getFormDataFromDOM();
                  if (!fixedHeight) {
                    that.textareaInputList[i].style.height =
                      that.textareaInputList[i].scrollHeight + "px";
                  }
                });
                that.textareaInputList[i].addEventListener("focus", () => {
                  setTimeout(() => {
                    that.textareaInputList[i].scrollIntoView({
                      block: "center",
                      behavior: "smooth",
                    });
                  }, 300);
                });
                if (!fixedHeight) {
                  setTimeout(() => {
                    that.textareaInputList[i].style.height =
                      that.textareaInputList[i].scrollHeight + "px";
                  }, 100);
                }
              }
              // 微信小程序兼容：处理 table 宽度并强制换行
              const tableList = document.querySelectorAll("#task-detail table");
              for (let i = 0; i < tableList.length; i++) {
                const tbl = tableList[i];
                // 移除 HTML width 属性
                tbl.removeAttribute("width");
                // 宽度最大100%，列宽自适应：table-layout:fixed，列宽根据首行内容自动分配
                tbl.style.width = "100%";
                tbl.style.maxWidth = "100%";
                tbl.style.tableLayout = "fixed";
                // keep-all：保持英语单词完整；break-word：单词超宽时才断词
                tbl.style.wordBreak = "keep-all";
                tbl.style.overflowWrap = "break-word";
              }
              const tdList = document.querySelectorAll(
                "#task-detail td, #task-detail th",
              );
              for (let i = 0; i < tdList.length; i++) {
                const td = tdList[i];
                // 移除 HTML width/nowrap 属性（Word 转 HTML 常用）
                td.removeAttribute("width");
                td.removeAttribute("nowrap");
                // 移除 style 中的固定宽度，让列宽根据 table-layout:fixed 自动分配
                td.style.width = "";
                td.style.maxWidth = "none";
                // 强制内联样式覆盖所有换行相关属性
                td.style.whiteSpace = "normal";
                // keep-all：保持英语单词完整；break-word：单词超宽时才断词
                td.style.wordBreak = "keep-all";
                td.style.wordWrap = "break-word";
                td.style.overflowWrap = "break-word";
                // 强制清除 td 内所有子元素上的换行限制（含 nowrap 属性和样式）
                const children = td.querySelectorAll("*");
                for (let j = 0; j < children.length; j++) {
                  const child = children[j];
                  child.removeAttribute("nowrap");
                  child.style.whiteSpace = "normal";
                  child.style.wordBreak = "keep-all";
                  child.style.wordWrap = "break-word";
                  child.style.overflowWrap = "break-word";
                  if (child.style.width && child.style.width.includes("pt")) {
                    child.style.width = "";
                  }
                  // 图片需要限制最大宽度，其他元素不限制，避免影响 table 宽度计算
                  if (child.tagName === "IMG") {
                    child.style.maxWidth = "100%";
                  } else {
                    child.style.maxWidth = "none";
                  }
                }
              }
              // 移除 col/colgroup 上的宽度限制（Word 转 HTML 常用）
              const colList = document.querySelectorAll(
                "#task-detail col, #task-detail colgroup",
              );
              for (let i = 0; i < colList.length; i++) {
                colList[i].removeAttribute("width");
                colList[i].style.width = "";
              }
              // 如果第一列的内容只有数字，则第一列设置固定宽度 40px
              const tableListForFirstCol = document.querySelectorAll(
                "#task-detail table",
              );
              for (let i = 0; i < tableListForFirstCol.length; i++) {
                const tbl = tableListForFirstCol[i];
                const firstRow = tbl.querySelector("tr");
                if (firstRow) {
                  const firstCell = firstRow.querySelector("td, th");
                  if (firstCell) {
                    const text = (firstCell.textContent || "").trim();
                    if (text && /^\d+$/.test(text)) {
                      firstCell.style.width = "40px";
                    }
                  }
                }
              }
              if (that.answers && that.answers.length) {
                setTimeout(() => {
                  that.answersToInput(that.answers);
                  that.getFormDataFromDOM();
                }, 0);
              } else {
                this.getStudentTesrLoadCache();
              }
            }, 0);
            if (data.paperType === "8") {
              this.wakongHandle();
            }
          }
          // 学生做作业模式：与试卷预览（getPaperDetail）做相同处理——按小题注入
          // 「作文要求 / 要求附件」（来源 flows[].scorePointList，见 util/flowExtra.js）。
          // 试卷级门：仅 data.paperType 为 4 / 5 的试卷；
          // 小题级门：仅该小题 knowledgeType 为 12（写作类，在 util 里逐小题判断）。
          // 特意放在 data.content 判断之外：paperType=5 的答题卡内容在 data.answerSheet 里，
          // 可能没有 content，这种情况同样要把内容注入进答题卡。
          // 学生端不会调 getInputSortUtil（不展示标准答案），空位([name=tagId])始终存在，
          // 定位不受影响；延迟一个 setTimeout 是为了让 v-html 正文与答题卡子组件先渲染完，
          // 且早于 answersToInput 的答案回填。
          const studentFlowList =
            (data.flows && data.flows.length ? data.flows : data.taskFlowList) ||
            [];
          if (
            studentFlowList.length > 0 &&
            isFlowExtraPaperType(data.paperType)
          ) {
            setTimeout(() => {
              this.injectFlowExtras(studentFlowList);
            }, 0);
          }
          // 语音录入（knowledgeType 28/33）：给该小题的答案空位右侧注入录音图标。
          // 两点与上面的「作文要求」注入保持一致（都是按小题注入、都要能进答题卡）：
          //   1. 不设试卷级门——28/33 是**小题**级字段，与 paperType 无关；
          //   2. 特意放在 data.content 判断之外——paperType=5 的答题卡内容在
          //      data.answerSheet 里，可能没有 content，这种情况同样要挂上图标。
          // 图标只作为空位的兄弟节点插入、不替换空位，所以不存在「必须早于取
          // textInputList / textareaInputList」的时序约束；util 内置幂等（先清后插），
          // 重复进入也不会叠加。
          if (studentFlowList.length > 0) {
            setTimeout(() => {
              this.injectVoiceInputButtons(studentFlowList);
            }, 0);
          }
        });
      if (this.query.status == "4") {
        this.getResult();
      }
    },
    onBegin() {
      req
        .post("/api/exam/appApi/userTaskStart", {
          id: this.query.id,
        })
        .then((res) => {
          const errorCode = res.data.errorCode;
          const errorDesc = res.data.errorDesc;
          if (errorCode == "900052") {
            Dialog.confirm({
              title: "提示",
              message: errorDesc,
              allowHtml: true,
            }).then(() => {
              wx.miniProgram.redirectTo({
                url: "/pages/common-index/index",
              });
            });
          } else if (errorCode) {
            Toast(errorDesc);
          } else {
            this.data = {
              ...this.data,
              ...res.data.data,
              content: this.data.content,
              answerSheet: this.data.answerSheet,
            };
          }
          this.$nextTick(() => {
            const taskContent = document.getElementById("homework-page");
            taskContent.scrollTop = 0;
          });
        });
    },

    onPhoto() {
      // 单选题多个input同一个id，这里用对象储存，避免重复记录
      const radioAnswers = {};
      const checkAnswers = {};
      const answers = [];
      const self = this;
      // 获取所有选择题填写答案
      for (let i = 0; i < this.radioInputList.length; i++) {
        const item = this.radioInputList[i];
        const text = item.value;
        const tagId = item.attributes.name.value;
        radioAnswers[tagId] = radioAnswers[tagId] || "";
        if (item.checked) {
          radioAnswers[tagId] = text.slice(0, 1);
        }
      }
      for (const key in radioAnswers) {
        answers.push(key);
      }

      // 获取所有多选题填写答案
      for (let i = 0; i < this.checkboxInputList.length; i++) {
        const item = this.checkboxInputList[i];
        const text = item.value;
        const tagId = item.attributes.name.value;
        checkAnswers[tagId] = checkAnswers[tagId] || "";
        if (item.checked) {
          checkAnswers[tagId] += text.slice(0, 1);
        }
      }
      for (const key in checkAnswers) {
        answers.push(key);
      }

      // 获取所有填空题填写答案
      for (let i = 0; i < this.textInputList.length; i++) {
        const item = this.textInputList[i];
        const tagId = item.attributes.name.value;
        answers.push(tagId);
      }

      // 获取所有作文题填写答案
      for (let i = 0; i < this.textareaInputList.length; i++) {
        const item = this.textareaInputList[i];
        const tagId = item.attributes.name.value;
        answers.push(tagId);
      }
      let url = `/pages/zizhu/index?taskId=${this.query.id}&answers=${answers}`;
      // if(this.data.paperFormat && this.data.paperFormat !== ''){
      //   url= `/pages/zizhu/index?taskId=${this.query.id}`
      // }
      console.log(url);
      wx.miniProgram.redirectTo({ url });
    },

    onSubmit() {
      if (this.isSubmitting) return;
      // 高峰提示：仅 PAPER_TYPE=1 且在高峰时段（09:00-12:00、14:00-18:00）时展示
      const showPeakTip =
        String(this.data.paperType) === "1" && this.isPeakHour();
      if (this.hasEmpty) {
        Dialog.confirm({
          title: "完成练习",
          message:
            '<div class="red">还有未完成的题目，是否仍要提交练习？</div>',
          allowHtml: true,
        }).then(() => {
          this.doSubmitReq(true, true, showPeakTip);
        });
      } else {
        Dialog.confirm({
          title: "完成练习",
          message: "是否提交该练习",
          allowHtml: true,
        }).then(() => {
          this.doSubmitReq(true, true, showPeakTip);
        });
      }
    },
    doSubmitReq(backToIndex, showToast, showPeakTip) {
      if (this.isSubmitting) return;
      this.isSubmitting = true;
      Toast.loading({
        message: "提交中...",
        forbidClick: true,
        duration: 0,
      });
      req
        .post("/api/exam/appApi/userTaskSubmit", {
          id: this.query.id,
          answers: this.answers.map((answer) => {
            answer.text = answer.text.replace(/(^\s*)|(\s*$)/g, "");
            return answer;
          }),
        })
        .then((res) => {
          Toast.clear();
          const errorCode = res.data.errorCode;
          const errorDesc = res.data.errorDesc;
          if (errorCode == "900088") {
            Dialog.confirm({
              title: "提示",
              message: errorDesc,
              allowHtml: true,
            }).then(() => {});
            return;
          }
          if (errorCode == "900052") {
            Dialog.confirm({
              title: "提示",
              message: errorDesc,
              allowHtml: true,
            }).then(() => {
              wx.miniProgram.redirectTo({
                url: "/pages/common-index/index",
              });
            });
            return;
          }
          if (res.data.success) {
            if (showPeakTip) {
              // 提交高峰提示：仅在 PAPER_TYPE=1 且处于高峰时段（09:00-12:00、14:00-18:00）时展示，5 秒后自动消失
              // zIndex 高于 Dialog 默认层级，确保提示不会被「时间限制到了」弹窗遮挡
              Toast({
                message:
                  "当前为提交高峰，预计19点后更新状态与成绩，如遇延迟敬请谅解，感谢您的耐心等待。",
                duration: 5000,
                zIndex: 2100,
              });
            } else if (showToast) {
              Toast("作业提交成功！");
            }
            if (backToIndex) {
              if (showPeakTip) {
                // 高峰提示需完整展示 5 秒后再跳转，避免提示被页面跳转打断
                setTimeout(() => {
                  wx.miniProgram.redirectTo({
                    url: "/pages/common-index/index",
                  });
                }, 5000);
              } else {
                wx.miniProgram.redirectTo({
                  url: "/pages/common-index/index",
                });
              }
            }
          }
        })
        .catch(() => {
          Toast.clear();
        })
        .finally(() => {
          this.isSubmitting = false;
        });
    },
    onFinish() {
      // 倒计时结束自动提交：仅 PAPER_TYPE=1 且在高峰时段（09:00-12:00、14:00-18:00）提示提交高峰
      const showPeakTip =
        String(this.data.paperType) === "1" && this.isPeakHour();
      this.doSubmitReq(false, false, showPeakTip);
      if (showPeakTip) {
        // 高峰提示需完整展示 5 秒后再弹「时间限制到了」提示框，避免被弹窗遮挡或跳转打断
        setTimeout(() => {
          this.showTimeUpDialog();
        }, 5000);
      } else {
        this.showTimeUpDialog();
      }
    },
    showTimeUpDialog() {
      Dialog.confirm({
        title: "提示",
        message: "时间限制到了，作答结束，已做答案会自动上传",
        showCancelButton: false,
      }).then(() => {
        wx.miniProgram.redirectTo({
          url: "/pages/common-index/index",
        });
        // this.doSubmitReq(true, true);
      });
    },
    isPeakHour() {
      const now = new Date();
      const minutes = now.getHours() * 60 + now.getMinutes();
      const isMorning = minutes >= 9 * 60 && minutes < 12 * 60; // 09:00-12:00
      const isAfternoon = minutes >= 14 * 60 && minutes < 18 * 60; // 14:00-18:00
      // return isMorning || isAfternoon;
      return false
    },
    getPaperDetail() {
      req
        .post("/api/exam/paperDetail", {
          id: this.query.id,
        })
        .then((res) => {
          const data = res.data.data || {};
          this.data = data;
          const that = this;
          document.title = data.title;
          if (data.content) {
            setTimeout(() => {
              const detailDOM = document.querySelector("#task-detail");
              const imgDomList = document.querySelectorAll("#task-detail img");
              const imgList = [];
              if (imgDomList && imgDomList.length) {
                for (let i = 0; i < imgDomList.length; i++) {
                  imgList.push(imgDomList[i].src);
                }
                for (let i = 0; i < imgDomList.length; i++) {
                  const item = imgDomList[i];
                  item.setAttribute("loading", "lazy");
                  item.setAttribute("decoding", "async");
                  item.addEventListener("click", (e) => {
                    const src = e.target.src;
                    ImagePreview({
                      images: imgList,
                      closeable: true,
                      startPosition: i,
                    });
                  });
                }
              }
              // 插入播放按钮
              const audioTagList = document.querySelectorAll("audio");
              if (audioTagList && audioTagList.length > 0) {
                // iOS音频初始化处理
                for (let i = 0; i < audioTagList.length; i++) {
                  audioTagList[i].setAttribute("preload", "metadata");
                  audioTagList[i].setAttribute("webkit-playsinline", "true");
                  audioTagList[i].setAttribute("playsinline", "true");
                }

                for (let i = 0; i < audioTagList.length; i++) {
                  const newNode = document.createElement("div");
                  newNode.className = "play-btn-container";
                  newNode.id = "audio" + i;
                  const parent = audioTagList[i].parentNode;
                  newNode.innerHTML = `
                    <svg viewBox="0 0 1060 1060"><path d="M 530 530 m 0, -500 a 500, 500 0 1, 1 0, 1000 a 500, 500 0 1, 1 0, -1000" class="van-circle__hover" style="fill: none; stroke: rgb(255, 255, 255); stroke-width: 60px;"></path><path d="M 530 530 m 0, -500 a 500, 500 0 1, 1 0, 1000 a 500, 500 0 1, 1 0, -1000" stroke="#ff1717" class="van-circle__layer" style="fill: none; stroke: rgb(255, 23, 23); stroke-width: 61px; stroke-dasharray: 0px, 3140px;"></path></svg>
                    <img src="${bluePlayImg}" /><span style="position: absolute;bottom:-20px;width: 120px;display:inline-block">听力音频${i +
                    1}</span>
                  `;
                  // parent.insertBefore(newNode, audioTagList[i]);
                  parent.replaceChild(newNode, audioTagList[i]);

                  audioTagList[i].addEventListener("ended", (event) => {
                    that.notPlaying = true;
                    that.audioIndex = -1;
                    that.audioBtnList[i].children[0].style.display = "none";
                    that.audioBtnList[i].children[1].src = bluePlayImg;
                    // iOS 18.5兼容：重置所有按钮状态和进度条
                    for (let j = 0; j < that.audioBtnList.length; j++) {
                      that.audioBtnList[j].children[1].src = bluePlayImg;
                      that.resetProgressBar(j);
                    }
                  });
                  audioTagList[i].addEventListener("timeupdate", (event) => {
                    // iOS 18.5兼容：增强进度条更新逻辑
                    try {
                      const audio = that.audioTagList[i];
                      if (
                        audio &&
                        audio.duration &&
                        !isNaN(audio.duration) &&
                        audio.duration > 0
                      ) {
                        const progress = audio.currentTime / audio.duration;
                        // 确保只有当前播放的音频才更新进度条
                        if (that.audioIndex === i && !that.notPlaying) {
                          that.updateProgressBar(i, progress);
                        }
                      }
                    } catch (error) {
                      console.log("Progress update error:", error);
                    }
                  });
                  audioTagList[i].addEventListener("play", (event) => {
                    // iOS 18.5兼容：确保状态正确同步
                    that.notPlaying = false;
                    that.audioIndex = i;
                    // 使用统一的状态更新函数确保iOS 18.5兼容性
                    that.updateAudioButtonState(i, true);
                  });

                  // iOS兼容性：添加音频加载和错误处理
                  audioTagList[i].addEventListener("loadstart", (event) => {
                    console.log("Audio loading started");
                  });

                  audioTagList[i].addEventListener("error", (event) => {
                    console.log("Audio error:", event);
                    that.notPlaying = true;
                    that.audioIndex = -1;
                    if (that.audioBtnList && that.audioBtnList[i]) {
                      that.audioBtnList[i].children[1].src = bluePlayImg;
                      that.audioBtnList[i].children[0].style.display = "none";
                    }
                  });
                }
              }
              that.audioTagList = audioTagList;
              setTimeout(() => {
                const audioBtnList = document.querySelectorAll(
                  ".play-btn-container",
                );
                for (let i = 0; i < audioBtnList.length; i++) {
                  if (audioBtnList[i]) {
                    audioBtnList[i].children[1].style.display = "block";
                    audioBtnList[i].addEventListener("click", (e) => {
                      const item = e.currentTarget;
                      // 当前点击的第几个audio
                      const index = Number(item.id.slice(5));

                      // 如果点击的是当前正在播放的音频，则暂停/播放
                      if (that.audioIndex == index && !that.notPlaying) {
                        that.audioTagList[index].pause();
                        // iOS 18.5兼容：使用统一的状态更新函数
                        that.updateAudioButtonState(index, false);
                        that.notPlaying = true;
                      } else {
                        // 先暂停所有正在播放的音频
                        for (let j = 0; j < that.audioTagList.length; j++) {
                          if (!that.audioTagList[j].paused) {
                            that.audioTagList[j].pause();
                            that.audioBtnList[j].children[1].src = bluePlayImg;
                            that.audioBtnList[j].children[0].style.display =
                              "none";
                          }
                        }

                        // 立即更新状态和UI（iOS 18.5兼容）
                        that.audioIndex = index;
                        that.notPlaying = false;
                        // iOS 18.5兼容：使用统一的状态更新函数
                        that.updateAudioButtonState(index, true);

                        // 播放点击的音频，iOS兼容处理
                        const playPromise = that.audioTagList[index].play();
                        if (playPromise !== undefined) {
                          playPromise
                            .then(() => {
                              // 播放成功确认（iOS 18.5中可能需要额外确认）
                              setTimeout(() => {
                                if (!that.audioTagList[index].paused) {
                                  that.notPlaying = false;
                                  that.updateAudioButtonState(index, true);
                                }
                              }, 100);
                            })
                            .catch((error) => {
                              // 播放失败时重置状态
                              console.log("Audio play failed:", error);
                              that.notPlaying = true;
                              that.audioIndex = -1;
                              that.audioBtnList[
                                index
                              ].children[1].src = bluePlayImg;
                              that.audioBtnList[
                                index
                              ].children[0].style.display = "none";
                            });
                        } else {
                          // 旧版浏览器兼容
                          that.notPlaying = false;
                          that.updateAudioButtonState(index, true);
                        }
                      }
                    });
                  }
                }
                that.audioBtnList = audioBtnList;
              }, 0);
              that.detailDOM = detailDOM;
              if (!detailDOM) {
                return;
              }
              // 修复 Word 转 HTML 带来的负 text-indent：负缩进会让首行被容器 overflow-x:hidden 裁切，导致开头文字显示不全。
              // 保留 text-indent 的悬挂缩进效果，仅补等量左内边距把整段右移，使首行回到容器内不被裁切。
              that.pList = document.querySelectorAll("#task-detail p");
              for (let i = 0; i < that.pList.length; i++) {
                let tag = that.pList[i];
                if (!tag.style.textAlign) {
                  tag.style.textAlign = "left";
                }
                if (tag.style.textIndent && parseFloat(tag.style.textIndent) < 0) {
                  const indentPx = (Math.abs(parseFloat(tag.style.textIndent)) / 72) * 96; // pt -> px
                  const existPad = tag.style.paddingLeft
                    ? parseFloat(tag.style.paddingLeft)
                    : 0;
                  tag.style.paddingLeft = existPad + indentPx + "px";
                }
              }
              that.radioInputList = document.querySelectorAll(
                'input[type="radio"]',
              );
              // radio类型的input，让其父元素单独占一行
              that.setRadioParentBlock(that.radioInputList);

              that.checkboxInputList = document.querySelectorAll(
                'input[type="checkbox"]',
              );
              that.textInputList = document.querySelectorAll(
                'input[type="text"]',
              );
              that.textareaInputList = document.querySelectorAll("textarea");
              // 首次初始化页面时绑定事件 监听输入变化 重复执行此函数结果不变
              detailDOM.addEventListener("click", (e) => {
                that.getFormDataFromDOM();
              });
              const clientWidth =
                (document.body.clientWidth ||
                  document.getElementsByTagName("html")[0].offsetWidth) * 0.92;
              for (let i = 0; i < that.textInputList.length; i++) {
                that.textInputList[i].addEventListener("input", (e) => {
                  that.getFormDataFromDOM();
                  let width = Math.max(that.textInputList[i].scrollWidth, 80);
                  width = Math.min(width, clientWidth);
                  that.textInputList[i].style.width = width + "px";
                });
                that.textInputList[i].addEventListener("focus", () => {
                  setTimeout(() => {
                    that.textInputList[i].scrollIntoView({
                      block: "center",
                      behavior: "smooth",
                    });
                  }, 300);
                });
                setTimeout(() => {
                  let width = Math.max(that.textInputList[i].scrollWidth, 80);
                  width = Math.min(width, clientWidth);
                  that.textInputList[i].style.width = width + "px";
                }, 100);
              }
              for (let i = 0; i < that.textareaInputList.length; i++) {
                // 写作(12)小题的答案框固定 10 行高度，不参与下面的「随内容自动增高」，
                // 否则会被 scrollHeight 一路撑高、永远出不来滚动条
                const fixedHeight = that.isFixedHeightTextarea(
                  that.textareaInputList[i],
                );
                that.textareaInputList[i].addEventListener("input", (e) => {
                  that.getFormDataFromDOM();
                  if (!fixedHeight) {
                    that.textareaInputList[i].style.height =
                      that.textareaInputList[i].scrollHeight + "px";
                  }
                });
                that.textareaInputList[i].addEventListener("focus", () => {
                  setTimeout(() => {
                    that.textareaInputList[i].scrollIntoView({
                      block: "center",
                      behavior: "smooth",
                    });
                  }, 300);
                });
                if (!fixedHeight) {
                  setTimeout(() => {
                    that.textareaInputList[i].style.height =
                      that.textareaInputList[i].scrollHeight + "px";
                  }, 100);
                }
              }
              // 微信小程序兼容：处理 table 宽度并强制换行
              const tableList = document.querySelectorAll("#task-detail table");
              for (let i = 0; i < tableList.length; i++) {
                const tbl = tableList[i];
                // 移除 HTML width 属性
                tbl.removeAttribute("width");
                // 宽度最大100%，列宽自适应：table-layout:fixed，列宽根据首行内容自动分配
                tbl.style.width = "100%";
                tbl.style.maxWidth = "100%";
                tbl.style.tableLayout = "fixed";
                // keep-all：保持英语单词完整；break-word：单词超宽时才断词
                tbl.style.wordBreak = "keep-all";
                tbl.style.overflowWrap = "break-word";
              }
              const tdList = document.querySelectorAll(
                "#task-detail td, #task-detail th",
              );
              for (let i = 0; i < tdList.length; i++) {
                const td = tdList[i];
                // 移除 HTML width/nowrap 属性（Word 转 HTML 常用）
                td.removeAttribute("width");
                td.removeAttribute("nowrap");
                // 移除 style 中的固定宽度，让列宽根据 table-layout:fixed 自动分配
                td.style.width = "";
                td.style.maxWidth = "none";
                // 强制内联样式覆盖所有换行相关属性
                td.style.whiteSpace = "normal";
                // keep-all：保持英语单词完整；break-word：单词超宽时才断词
                td.style.wordBreak = "keep-all";
                td.style.wordWrap = "break-word";
                td.style.overflowWrap = "break-word";
                // 强制清除 td 内所有子元素上的换行限制（含 nowrap 属性和样式）
                const children = td.querySelectorAll("*");
                for (let j = 0; j < children.length; j++) {
                  const child = children[j];
                  child.removeAttribute("nowrap");
                  child.style.whiteSpace = "normal";
                  child.style.wordBreak = "keep-all";
                  child.style.wordWrap = "break-word";
                  child.style.overflowWrap = "break-word";
                  if (child.style.width && child.style.width.includes("pt")) {
                    child.style.width = "";
                  }
                  // 图片需要限制最大宽度，其他元素不限制，避免影响 table 宽度计算
                  if (child.tagName === "IMG") {
                    child.style.maxWidth = "100%";
                  } else {
                    child.style.maxWidth = "none";
                  }
                }
              }
              // 移除 col/colgroup 上的宽度限制（Word 转 HTML 常用）
              const colList = document.querySelectorAll(
                "#task-detail col, #task-detail colgroup",
              );
              for (let i = 0; i < colList.length; i++) {
                colList[i].removeAttribute("width");
                colList[i].style.width = "";
              }
              // 如果第一列的内容只有数字，则第一列设置固定宽度 40px
              const tableListForFirstCol = document.querySelectorAll(
                "#task-detail table",
              );
              for (let i = 0; i < tableListForFirstCol.length; i++) {
                const tbl = tableListForFirstCol[i];
                const firstRow = tbl.querySelector("tr");
                if (firstRow) {
                  const firstCell = firstRow.querySelector("td, th");
                  if (firstCell) {
                    const text = (firstCell.textContent || "").trim();
                    if (text && /^\d+$/.test(text)) {
                      firstCell.style.width = "40px";
                    }
                  }
                }
              }
              if (that.answers && that.answers.length) {
                setTimeout(() => {
                  that.answersToInput(that.answers);
                  that.getFormDataFromDOM();
                }, 0);
              } else {
                this.getStudentTesrLoadCache();
              }
              // 试卷预览模式：展示标准答案（填空 input 替换为答案 span、选择题按答案选中并禁用），
              // 与 preTask.vue 预览页 getInputSortUtil 行为保持一致
              const previewFlowList = data.taskFlowList || data.flows || [];
              if (previewFlowList.length > 0) {
                // 给分点内容按小题注入：作文要求 / 要求附件
                // （scorePointList[].simpleTaskSaveDto.content / contentUrl）。
                // 试卷级门：仅 data.type 为 4 / 5 的试卷（教师端预览口径）；
                // 小题级门：仅该小题 knowledgeType 为 12（写作类，在 util 里逐小题判断）。
                // 必须放在 getInputSortUtil 之前：空位([name=tagId])还在，才能定位到该小题插入。
                if (isFlowExtraPaperType(data.type)) {
                  this.injectFlowExtras(previewFlowList);
                }
                getInputSortUtil(previewFlowList);
              }
            }, 0);
          }
        });
    },

    wakongHandle() {
      //挖空题
      setTimeout(() => {
        const data = this.data;
        const inputList = document.querySelectorAll("input");
        let mapTagId = {};
        if (data.tagIds && data.tagIds !== "") {
          let mt = data.tagIds.split(",");
          if (mt && mt.length > 0) {
            mt.forEach((m) => {
              if (mapTagId[m] === undefined) mapTagId[m] = m;
            });
          }
        }
        let mapTaskFlow = {};
        if (data.taskFlowList && data.taskFlowList.length > 0) {
          data.taskFlowList.forEach((m) => {
            if (mapTaskFlow[m.tagId] === undefined) mapTaskFlow[m.tagId] = m;
          });
        }
        for (let i = 0; i < inputList.length; i++) {
          let q = inputList[i];
          const parent = q.parentNode;
          if (mapTagId[q.name] === undefined) {
            const newNode = document.createElement("span");
            const answer =
              mapTaskFlow[q.name] !== undefined
                ? mapTaskFlow[q.name].answer
                : "";
            newNode.innerHTML = `${answer}`;
            parent.replaceChild(newNode, q);
          }
        }
      }, 0);
    },
  },
  components: {
    Countdown,
    BeginTask,
    TaskEvaluation,
    AnswerSheet,
  },
};
</script>

<style lang="less">
.homework-page {
  width: 100%;
  min-height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;
  // 禁止 iOS 橡皮筋效果，防止滚动到顶/底时露出空白
  overscroll-behavior: none;
  // iOS：软键盘弹出时容器自适应收缩，避免内容被遮挡
  height: auto;
  // 安卓：保持固定高度，否则键盘弹出后无法上下滑动
  &.android {
    height: 100vh;
  }
}
.task-container {
  padding: 0 4% 0.4rem;
  width: 100%;
  box-sizing: border-box;
  .MsoNormal {
    font-size: medium !important;
  }
  .task-content {
    white-space: normal;
    word-break: break-word;
    width: 100%;
    box-sizing: border-box;
    -webkit-overflow-scrolling: touch;
    img {
      max-width: 100% !important;
      height: auto !important;
    }
    & > * {
      // width: 100% !important;
      // overflow-x: auto;
      & input {
        overflow-x: auto;
        /*width: 80px;*/
        /*max-width: 80px;*/
      }
    }
  }
  .van-action-sheet {
    min-height: 20%;
    width: 92%;
    left: 4%;
    bottom: 4%;
    box-shadow: 0 -1px 10px rgba(0, 0, 0, 0.2);
    border-radius: 0.1rem;
  }
  .van-action-sheet__content {
    height: 100%;
  }
}
.task-detail {
  padding-bottom: 0.3rem;
  overscroll-behavior: none;
  font-family: "Times New Roman";
  font-size: 10.5pt;
  // font-size: 0.42rem;
  line-height: 1.6em;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}

// type=12（作文）展示「作文要求」块时，隐藏正文内容，避免重复
.task-content--hidden {
  display: none !important;
}

.MsoNormal {
  font-size: 0.42rem;
}

.btn-container {
  padding: 0.3rem;
  display: flex;
  justify-content: space-around;
}
/*.exam-content>>>p{*/
/*  white-space: normal;*/
/*  word-break:keep-all;*/
/*}*/
/*.exam-content>>>span{*/
/*  white-space: normal;*/
/*  word-break:keep-all;*/
/*}*/
.paizhao-btn {
  position: relative;
  .tip-icon {
    position: absolute;
    right: -11px;
    top: -11px;
    font-size: 20px;
    color: #ffba00;
    padding: 5px;
  }
}
.dcsp-tip {
  width: 80vw;
  line-height: 1.5;
  padding: 40px 20px;
}
.img-box {
  width: 90vw;
  height: 90vh;
  overflow-y: auto;
}
.tip-img {
  width: auto;
  height: auto;
  max-width: 90vw;
  max-height: 90vh;
  object-fit: contain;
}

.tip-popup.van-popup {
  background-color: rgba(255, 255, 255, 0);
  .van-popup__close-icon {
    color: #000;
  }
}
.task-container .task-content table {
  width: 100% !important;
  max-width: 100% !important;
  table-layout: fixed !important;
  word-break: keep-all !important;
  overflow-wrap: break-word !important;
  margin-left: 0 !important;
}
.task-container .task-content table tr {
  height: auto !important;
  td,
  th {
    height: auto !important;
    word-break: keep-all !important;
    word-wrap: break-word !important;
    overflow-wrap: break-word !important;
    white-space: normal !important;
    // 限制 input 宽度最大为所在 td 宽度 - 10px（避免撑破列宽）
    input {
      max-width: calc(100% - 10px) !important;
      width: calc(100% - 10px) !important;
      box-sizing: border-box !important;
    }
    p,
    span,
    div {
      word-break: keep-all !important;
      word-wrap: break-word !important;
      overflow-wrap: break-word !important;
      white-space: normal !important;
    }
  }
}

.composition-requirement {
  margin: 0.2rem 0 0.3rem;
  padding: 0.3rem;
  background-color: #fff8f0;
  border-radius: 0.12rem;
  border: 1px solid #ffe9cc;
  box-sizing: border-box;
  .composition-title {
    font-size: 0.4rem;
    font-weight: bold;
    color: #333;
    line-height: 1.5;
    margin-bottom: 0.24rem;
    text-align: center;
  }
  .composition-label {
    font-size: 0.36rem;
    font-weight: bold;
    color: #e6a23c;
    line-height: 1.5;
    margin: 0.24rem 0 0.12rem;
    &:first-of-type {
      margin-top: 0;
    }
  }
  .composition-content {
    font-size: 0.34rem;
    color: #666;
    line-height: 1.6;
    word-break: break-word;
    white-space: normal;
    img {
      width: 100% !important;
      max-width: 100% !important;
      height: auto !important;
      display: block;
      margin: 0.1rem 0;
    }
  }
  .composition-attachment {
    display: block;
    width: 100%;
    max-width: 100%;
    height: auto;
    border-radius: 0.08rem;
    margin-top: 0.12rem;
  }
}

// 以下样式由 util/flowExtra.js 在试卷预览（paperDetail=1）与学生做作业时按小题注入到
// 正文/答题卡内部，类名与后台 Preview、StudentTask 及 preTask.vue 一致（两端口径统一）。
// 注入节点由 JS 生成、不带 data-v，本样式块未 scoped，可直接命中。

// 「作文要求 / 要求附件」块：配色与 preTask.vue「.essay-requirement」完全一致
// （底 #fdf6ec / 边框 #faecd8 / 正文 #303133 / 标签 #e6a23c / 附件图描边 #ebeef5），
// 字号保留本页 rem 750 设计尺度，不跟随预览页的 px 值。
.essay-requirement {
  margin: 0.2rem 0;
  padding: 0.2rem 0.24rem;
  background-color: #fdf6ec;
  border: 1px solid #faecd8;
  border-radius: 0.12rem;
  box-sizing: border-box;
  .essay-requirement__title,
  .essay-requirement__subtitle {
    font-size: 0.34rem;
    font-weight: bold;
    color: #e6a23c;
    line-height: 1.5;
    margin-bottom: 0.12rem;
  }
  .essay-requirement__content {
    font-size: 0.3rem;
    color: #303133;
    line-height: 1.6;
    word-break: break-word;
    white-space: normal;
    p {
      margin: 0.12rem 0;
    }
    img {
      max-width: 100%;
      height: auto;
    }
  }
  .essay-requirement__img {
    display: block;
    max-width: 100%;
    height: auto;
    border-radius: 0.08rem;
    border: 1px solid #ebeef5;
  }
}

// 写作(12)小题的答案框：由单行 input 换成满宽、10 行高的 textarea
//（见 replaceWritingInputWithTextarea）。节点由 JS 生成、不带 data-v，
// 本样式块未 scoped，可直接命中；字号沿用本页 rem 750 尺度。
// 高度固定 10 行（rows="10"）：height:auto 让浏览器按 rows 算高，
// !important 用于压掉 JS 自适应可能留下的行内 height；内容超出时内部上下滚动。
// 同时 JS 侧 isFixedHeightTextarea 会让这类 textarea 跳过「随内容自动增高」，两者配合缺一不可。
.writing-answer-textarea {
  display: block;
  width: 100% !important;
  height: auto !important;
  overflow-y: auto;
  box-sizing: border-box;
  margin: 0.12rem 0;
  padding: 0.12rem 0.16rem;
  border: 1px solid #dcdfe6;
  border-radius: 0.08rem;
  background-color: #fff;
  font-size: 0.3rem;
  line-height: 1.6;
  color: #303133;
  // 禁止手动拖拽放大，保证「最多 10 行」
  resize: none;
  vertical-align: top;
}
.writing-answer-textarea:focus {
  // --system-theme-color 在本 H5 项目里未定义，直接取设计稿绿色
  border-color: #11a983;
  outline: none;
}

// ==============================
// 语音录入（knowledgeType 28/33 小题）
// ==============================

// 答案空位右侧的录音图标：由 JS 注入、不带 data-v，
// 本样式块未 scoped，可直接命中；尺寸沿用本页 rem 750 尺度。
.voice-input-mic {
  display: inline-block;
  width: 0.44rem;
  height: 0.44rem;
  margin-left: 0.12rem;
  color: #1eb14d;
  vertical-align: middle;
  box-sizing: border-box;
  cursor: pointer;
  // 注入节点离输入框很近，给一点内边距扩大点击热区
  padding: 0.04rem;
  border-radius: 0.08rem;

  svg {
    display: block;
    width: 100%;
    height: 100%;
    fill: currentColor;
  }

  &:active {
    color: #17923f;
    background-color: #e8f7ee;
  }
}

// 弹窗：van-popup 默认居中，宽高按本页 rem 尺度给
.voice-popup {
  width: 6.4rem;
  // 固定弹窗高度，不随内容（占位/录音中/识别中/编辑）变化而伸缩
  height: 7rem;
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 0.12rem;
  overflow: hidden;

  .voice-popup__header {
    position: relative;
    height: 1.04rem;
    line-height: 1.04rem;
    padding: 0 0.32rem;
    border-bottom: 1px solid #f2f3f5;
  }
  .voice-popup__title {
    font-size: 0.32rem;
    color: #333;
    font-weight: 500;
  }
  .voice-popup__close {
    position: absolute;
    top: 0;
    right: 0.24rem;
    font-size: 0.44rem;
    line-height: 1.04rem;
    color: #999;
    cursor: pointer;
  }
  .voice-popup__body {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    padding: 0.32rem 0.36rem 0.5rem;
  }
}

.voice-input-area {
  width: 100%;
  box-sizing: border-box;
  // 录入区填满 body 剩余空间，配合固定弹窗高度保持不变
  flex: 1;
  min-height: 0;
  padding: 0.28rem 0.32rem;
  background: #e7eaf0;
  border-radius: 0.08rem;
  font-size: 0.28rem;
  color: #8a8f99;
  line-height: 1.7;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  // 按单词边界换行（单词保持完整），仅超长无空格单词才断开，避免中间截断
  word-break: normal;
  overflow-wrap: break-word;
  overflow: hidden;

  &.is-recording {
    background: #fdebe6;
    color: #e64545;
  }
  &.is-loading {
    background: #e6f4ff;
    color: #1989fa;
  }
  &.is-editing {
    align-items: stretch;
    justify-content: flex-start;
    text-align: left;
    color: #333;
  }
}

.voice-input-mic-icon {
  display: inline-block;
  width: 0.4rem;
  height: 0.4rem;
  margin-right: 0.12rem;
  vertical-align: middle;

  svg {
    display: block;
    width: 100%;
    height: 100%;
    fill: currentColor;
  }
}

.voice-input-pulse {
  animation: voice-input-pulse 1s ease-in-out infinite;
}
@keyframes voice-input-pulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.35;
  }
}

.voice-input-spin {
  display: inline-block;
  width: 0.32rem;
  height: 0.32rem;
  margin-right: 0.12rem;
  border: 2px solid #c8e3ff;
  border-top-color: #1989fa;
  border-radius: 50%;
  vertical-align: middle;
  animation: voice-input-spin 0.8s linear infinite;
}
@keyframes voice-input-spin {
  to {
    transform: rotate(360deg);
  }
}

.voice-input-textarea {
  width: 100%;
  // 填满录入区高度（弹窗固定高度时，识别结果多也不会撑高弹窗）
  height: 100%;
  padding: 0;
  border: none;
  background: transparent;
  color: #333;
  font-size: 0.28rem;
  line-height: 1.7;
  resize: none;
  outline: none;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  // 编辑态同样按单词换行，保持与占位/识别态一致
  word-break: normal;
  overflow-wrap: break-word;
  white-space: pre-wrap;
}

.voice-input-placeholder {
  color: #9aa0a6;
}

.voice-input-actions {
  margin-top: 0.4rem;
  display: flex;
  justify-content: center;
}
// 不用 flex gap（老版本 WebView 支持不全），用相邻兄弟外边距
.voice-input-btn + .voice-input-btn {
  margin-left: 0.24rem;
}

.voice-input-btn {
  min-width: 2.4rem;
  height: 0.72rem;
  padding: 0 0.32rem;
  border-radius: 0.1rem;
  background: #1eb14d;
  color: #fff;
  font-size: 0.28rem;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  cursor: pointer;
  user-select: none;
  transition: all 0.2s ease;

  .voice-btn-icon {
    display: block;
    width: 0.3rem;
    height: 0.3rem;
    margin-right: 0.12rem;
    fill: currentColor;
  }

  &:active {
    background: #17923f;
  }

  &.is-recording {
    background: #e64545;
  }

  // 识别中禁止再次触发（与 onVoiceBtnClick 的守卫一致）
  &.is-loading {
    opacity: 0.6;
    pointer-events: none;
  }
}
</style>
